import React from 'react';
import PropTypes from 'prop-types';

export class Observer extends React.Component {
    constructor(props) {
        super(props);

        const options = {
            root: null,
            threshold: 1.0,
            rootMargin: '0px'
        };

        this.isPrestine = true;
        this.target = React.createRef();

        this.observer = new IntersectionObserver(([entry]) => {
            if (this.isPrestine && entry && entry.intersectionRatio === 1) {
                this.props.onVisible();
                this.isPrestine = false;
            }
        }, options);
    }

    componentDidMount() {
        if (this.target.current) {
            this.observer.observe(this.target.current);
        }
    }

    componentWillUnmount() {
        this.observer.unobserve(this.target.current);
    }

    render() {
        return this.props.children(this.target);
    }
}

Observer.propTypes = {
    onVisible: PropTypes.func.isRequired
};
